import { render, staticRenderFns } from "./CreateEvent.vue?vue&type=template&id=c27fbc94&scoped=true&"
import script from "./CreateEvent.vue?vue&type=script&lang=js&"
export * from "./CreateEvent.vue?vue&type=script&lang=js&"
import style0 from "./CreateEvent.vue?vue&type=style&index=0&id=c27fbc94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27fbc94",
  null
  
)

export default component.exports